// Greenleaze variables
let init = false;
let initPrice = false;
var monthValues = [1, 12, 24, 36];
var rawrules = {};
var formated = {};
var priceRules = [];
let isCart = false;
let tva = 1.2;
let trackingId = null;
let isProcessingCart = false; // Add semaphore to prevent race conditions
let supportsAdditionalDeposit = false; // renseigné par getAllPriceRules (cf. `?raw=true`)

const greenleazePriceActualize = new Event('greenleazePriceActualize');
// Greenleaze functions
// Les règles Greenleaze sont des expressions JS (`~~` y tronque vers zéro) dans lesquelles
// [[nom]] désigne une variable. Depuis `?raw=true` (cf. getAllPriceRules), elles portent en
// plus [[additionalDepositTTC]] : l'apport SUPPLÉMENTAIRE choisi par le client, au-delà de
// l'apport par défaut du compte. Un placeholder inconnu vaut 0 plutôt que `undefined` :
// mieux vaut la règle de base qu'un NaN propagé jusqu'à l'affichage.
function parseRule(rule, values) {
  return new Function(
    'return ' +
      String(rule).replace(/\[\[(\w+)\]\]/g, (_, key) => {
        if (Object.prototype.hasOwnProperty.call(values, key)) return values[key];
        console.warn('parseRule: variable inconnue dans une règle Greenleaze:', key, rule);
        return 0;
      }),
  );
}

// additionalDepositTTC : apport SUPPLÉMENTAIRE (TTC) au-delà de l'apport par défaut du
// compte Greenleaze. À 0 — le cas de tous les appels d'affichage du thème — le calcul est
// strictement identique à celui d'avant l'ouverture de l'apport variable.
function getAllPricesForProduct(productPriceHT, additionalDepositTTC = 0) {
  const result = {};
  for (month in monthValues) {
    result[monthValues[month]] = getRuleByProductPriceAndDuration(
      productPriceHT,
      monthValues[month],
      additionalDepositTTC,
    );
  }
  return result;
}

function getRuleByProductPriceAndDuration(productPriceHT, duration = 36, additionalDepositTTC = 0) {
  // Protection contre les appels avant initialisation
  if (!Array.isArray(priceRules) || priceRules.length === 0) {
    console.warn('getRuleByProductPriceAndDuration: priceRules non initialisé');
    return { monthly: 0, initial: 0, total: '0.00' };
  }
  if (!Array.isArray(monthValues) || monthValues.length === 0) {
    console.warn('getRuleByProductPriceAndDuration: monthValues non initialisé');
    return { monthly: 0, initial: 0, total: '0.00' };
  }

  if (!monthValues.includes(duration)) duration = monthValues[monthValues.length - 1];
  const productPriceFormat = parseFloat(productPriceHT);

  const rule = priceRules.find(
    (priceRule) =>
      priceRule.duration == duration &&
      priceRule.minPrice <= productPriceFormat &&
      priceRule.maxPrice >= productPriceFormat,
  );

  // Protection si aucune règle trouvée
  if (!rule) {
    console.warn('getRuleByProductPriceAndDuration: aucune règle trouvée pour', {
      productPriceHT,
      duration,
      productPriceFormat,
    });
    return { monthly: 0, initial: 0, total: '0.00' };
  }

  const ruleValues = {
    tva,
    prixHT: productPriceHT,
    additionalDepositTTC: Math.max(0, Number(additionalDepositTTC) || 0),
  };
  const monthlyRule = parseRule(rule.rule, ruleValues);
  const depositRule = parseRule(rule.depositRule, ruleValues);

  const monthly = monthlyRule();
  const initial = depositRule();

  return {
    monthly,
    initial,
    total: (monthly * duration + initial).toFixed(2),
  };
}

// --- Apport de départ affiché par le thème ---------------------------------
// `depositRule` porte l'apport par défaut du compte Greenleaze (10 % du prix TTC sur les
// règles servies au 23/09/2026). Sur les vélos en TVA sur marge — variante dont « Facturer
// les taxes » est décoché — le thème part d'un apport PLANCHER de 20 % du prix affiché
// (mail Greenleaze du 28/08/2026) : c'est lui qui garde la mensualité compétitive sur ces
// vélos, dont le prix nourrit les règles sans avoir jamais porté de TVA.
//
// 🔴 Ce plancher n'était appliqué QUE par la modale de location : les mensualités
// « Dès X €/mois » de la fiche (CTA sticky, bandeau mobile, bloc prix) restaient, elles, sur
// l'apport par défaut. Sur un Cervélo à 3 999 € en TVA sur marge la fiche annonçait
// 131 €/mois (apport 479 €) et la modale ouverte par ce même clic 121,33 €/mois (apport
// 800 €) — mesuré le 22/09/2026. Tout affichage de mensualité passe DÉSORMAIS par
// getDisplayPriceForProduct() et tout plancher d'apport par getDisplayDepositFloor() : une
// seule définition, donc plus de divergence possible entre la fiche et la modale.
const MARGIN_VAT_DEPOSIT_RATE = 0.2;

// Apport de DÉPART (€ TTC) : l'apport Greenleaze par défaut, relevé au plancher 20 % sur les
// vélos en TVA sur marge. Sans prix affiché exploitable on s'en tient à l'apport par défaut,
// plutôt que d'inventer un plancher à 0.
function getDisplayDepositFloor(baseDeposit, priceDisplayed, marginVat) {
  const base = Number(baseDeposit) || 0;
  const displayed = Number(priceDisplayed) || 0;
  if (!marginVat || displayed <= 0) return base;
  return Math.max(base, Math.round(displayed * MARGIN_VAT_DEPOSIT_RATE));
}

// Mensualité + apport à AFFICHER pour une durée, apport de départ compris. Le supplément
// (plancher − apport par défaut) est amorti par les RÈGLES Greenleaze elles-mêmes, jamais par
// une formule maison : c'est le même appel que priceForDeposit() dans la modale, donc le même
// résultat au centime.
// ⚠️ Si le back ne sert pas les règles brutes (supportsAdditionalDeposit faux), le supplément
// reste sans effet sur la mensualité : on renvoie alors la mensualité de base — là encore le
// comportement EXACT de la modale, qui masque son curseur d'apport dans ce cas. Les deux
// surfaces restent alignées, sur l'ancien montant.
// `priceDisplayed` = prix affiché du vélo en euros (TTC si taxable, prix de vente sinon),
// `marginVat` = variante NON taxable. Les omettre revient à l'apport par défaut, soit
// exactement getRuleByProductPriceAndDuration().
function getDisplayPriceForProduct(productPriceHT, duration = 36, priceDisplayed = 0, marginVat = false) {
  const base = getRuleByProductPriceAndDuration(productPriceHT, duration, 0);
  const deposit = getDisplayDepositFloor(base.initial, priceDisplayed, marginVat);
  const extra = Math.max(0, deposit - base.initial);
  const priced =
    extra > 0 && supportsAdditionalDeposit ? getRuleByProductPriceAndDuration(productPriceHT, duration, extra) : null;
  const monthly = priced ? priced.monthly : base.monthly;
  return {
    monthly,
    initial: deposit,
    extraDeposit: extra,
    total: (monthly * duration + deposit).toFixed(2),
  };
}

// Endpoint des règles de prix. `?raw=true` : règles AVANT substitution des variables, donc
// portant encore [[additionalDepositTTC]]. Sans elles, l'apport supplémentaire ne pourrait
// qu'être envoyé à l'API, jamais prévisualisé — la mensualité de la modale ne suivrait pas
// le curseur. Le paramètre est ignoré par un back qui ne le connaît pas : on retombe alors
// sur les règles substituées, et supportsAdditionalDeposit passe à false (cf. plus bas).
const PRICING_ENDPOINT = '/apps/greenleaze-proxy/pricing?raw=true';

// Un aller-retour vers l'endpoint, SANS toucher à l'état global : partagé par
// l'initialisation et par Greenleaze.debugPricing(), pour que ce qu'on inspecte en console
// soit exactement ce que le thème consomme.
async function fetchPricingRules(url) {
  const target = url || PRICING_ENDPOINT;
  const response = await fetch(target, {
    method: 'GET',
    headers: {
      'ngrok-skip-browser-warning': 'true',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  });
  return { url: target, status: response.status, ok: response.ok, rules: await response.json() };
}

// Le back sert-il les règles brutes ? On cherche le placeholder dans la règle de MENSUALITÉ
// (`rule`) : c'est elle qui doit suivre le curseur. Dans une réponse substituée il a déjà été
// remplacé par 0, et il n'en reste que la cicatrice — `~~((1.2*[[prixHT]])/37)+1.5-0/35`.
function hasAdditionalDepositPlaceholder(rules, field) {
  const key = field || 'rule';
  return Array.isArray(rules) && rules.some((r) => /\[\[additionalDepositTTC\]\]/.test(String(r && r[key])));
}

// Query et réponse en clair dans la console. Sans ça, un curseur d'apport masqué ne dit pas
// LAQUELLE des causes s'applique : placeholder absent, proxy en 404, ou JSON vide.
function logPricingRules(res, label) {
  const rules = res.rules;
  const inMonthly = hasAdditionalDepositPlaceholder(rules, 'rule');
  const inDeposit = hasAdditionalDepositPlaceholder(rules, 'depositRule');
  console.groupCollapsed(
    '[greenleaze] ' +
      label +
      ' — HTTP ' +
      res.status +
      ' — apport variable : ' +
      (inMonthly ? 'DISPONIBLE' : 'INDISPONIBLE'),
  );
  console.log('GET', new URL(res.url, window.location.origin).href);
  console.log('[[additionalDepositTTC]] → mensualité :', inMonthly, '| apport :', inDeposit);
  if (Array.isArray(rules)) {
    console.table(
      rules.map((r) => ({
        durée: r.duration,
        prixHT_de: r.minPrice,
        prixHT_à: r.maxPrice,
        mensualité: r.rule,
        apport: r.depositRule,
      })),
    );
  } else {
    console.log('réponse inattendue (tableau de règles attendu) :', rules);
  }
  console.log('réponse brute :', rules);
  console.groupEnd();
}

// Rejoue la query à la demande. Indispensable parce que `window.greenleazeDebug` doit sinon
// être posé AVANT le chargement du script : sur une page déjà ouverte, c'est trop tard.
async function debugPricing(url) {
  const res = await fetchPricingRules(url);
  logPricingRules(res, 'règles de prix (debugPricing)');
  return res;
}

window.Greenleaze = window.Greenleaze || {};
window.Greenleaze.debugPricing = debugPricing;
// MARGIN_VAT_DEPOSIT_RATE est une `const` de module, donc ABSENTE de window (contrairement
// aux `function` de ce fichier) : on l'expose explicitement pour que la modale de location
// relise le taux canonique à l'appel, au lieu d'en garder une copie qui dériverait.
window.Greenleaze.marginVatDepositRate = MARGIN_VAT_DEPOSIT_RATE;

async function getAllPriceRules() {
  const pricing = await fetchPricingRules();
  rawrules = pricing.rules;

  // Query + réponse conservées pour inspection après coup, sans avoir à les rejouer.
  window.Greenleaze = window.Greenleaze || {};
  window.Greenleaze.pricing = pricing;
  if (window.greenleazeDebug) logPricingRules(pricing, 'règles de prix (chargement)');
  priceRules = rawrules;

  // Sans le placeholder, augmenter l'apport laisserait la mensualité figée : la modale
  // masque alors son curseur (cf. syncApportAvailability dans greenleaze-location-modal.js)
  // plutôt que d'afficher un montant qui ne bougerait pas.
  supportsAdditionalDeposit = hasAdditionalDepositPlaceholder(priceRules);
  window.Greenleaze.supportsAdditionalDeposit = supportsAdditionalDeposit;
  if (!supportsAdditionalDeposit) {
    console.warn(
      'Greenleaze: ' +
        PRICING_ENDPOINT +
        ' ne renvoie pas [[additionalDepositTTC]] — apport variable indisponible. ' +
        'Greenleaze.debugPricing() pour voir la query et sa réponse.',
    );
  }

  const uniqueDurations = new Set();
  for (let index = 0; index < priceRules.length; index++) {
    uniqueDurations.add(priceRules[index].duration);
  }
  monthValues = [...uniqueDurations].sort(function (a, b) {
    return a - b;
  });
  if (window.greenleazeDebug) console.log('Available durations:', monthValues);
  initPrice = true;
  if (window.greenleazeDebug) console.log('GREENLEAZE INITIALIZED');
  window.dispatchEvent(greenleazePriceActualize);
}

async function addTo(variantId, quantity) {
  var marquageVariantId = '41850827145384';
  var data = {
    id: variantId, // Id of the variant
    quantity: quantity, // Quantity
  };

  try {
    let response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error('Error during request: ' + response.statusText);
    }

    // Wait for the response to be converted to JSON
    let responseData = await response.json();

    if (
      String(variantId) !== marquageVariantId &&
      window.theme &&
      theme.cart &&
      typeof theme.cart.syncMarquage === 'function'
    ) {
      await theme.cart.syncMarquage();
    }
  } catch (error) {
    console.error('Erreur:', error);
  }
}

// Détection d'une ligne marquage, alignée sur theme.cart.syncMarquage
// (handle, product_handle ou variant id connu).
const MARQUAGE_VARIANT_ID = '41850827145384';
function isMarquageItem(it) {
  return (
    it.handle === 'marquage' ||
    it.product_handle === 'marquage' ||
    String(it.id) === MARQUAGE_VARIANT_ID ||
    String(it.variant_id) === MARQUAGE_VARIANT_ID
  );
}

// Retire les lignes marquage d'un panier avant envoi à Greenleaze : le marquage ne fait
// pas partie du contrat de location, il reste au panier Shopify (parcours achat) mais
// n'est jamais transmis à send-card. Les totaux sont recalculés en conséquence.
function stripMarquage(cart) {
  try {
    if (!cart || !Array.isArray(cart.items)) return cart;
    const items = cart.items.filter((it) => !isMarquageItem(it));
    if (items.length === cart.items.length) return cart;
    const totalPrice = items.reduce(
      (s, it) => s + (it.final_line_price != null ? it.final_line_price : (it.final_price || 0) * (it.quantity || 0)),
      0
    );
    return Object.assign({}, cart, {
      items: items,
      item_count: items.reduce((s, it) => s + (it.quantity || 0), 0),
      total_price: totalPrice,
      items_subtotal_price: totalPrice,
      total_discount: 0,
    });
  } catch (e) {
    console.error('stripMarquage error:', e);
    return cart;
  }
}

// Construit un panier réduit pour le mode acompte : uniquement le produit réservé
// (variantId), au lieu d'envoyer tout le panier. Le marquage en est exclu (cf. stripMarquage).
function buildAcompteCart(cart, variantId) {
  try {
    const bikeItems = cart.items.filter((it) => String(it.variant_id) === String(variantId));
    if (!bikeItems.length) return cart; // garde-fou : produit introuvable -> on n'altère rien

    const items = bikeItems.slice();

    const totalPrice = items.reduce(
      (s, it) => s + (it.final_line_price != null ? it.final_line_price : (it.final_price || 0) * (it.quantity || 0)),
      0
    );
    const itemCount = items.reduce((s, it) => s + (it.quantity || 0), 0);

    return Object.assign({}, cart, {
      items: items,
      item_count: itemCount,
      total_price: totalPrice,
      items_subtotal_price: totalPrice,
      total_discount: 0,
    });
  } catch (e) {
    console.error('buildAcompteCart error:', e);
    return cart;
  }
}

// Clés du payload send-card portant l'apport supplémentaire. Les DEUX orthographes sont
// envoyées : celle du mail Greenleaze du 28/08 (`additionnal`, deux « n ») et celle de leur
// placeholder de règle (`additional`, un seul). Testées séparément le 09/09, elles sont
// toutes deux acceptées sans erreur et sans effet (réservations velokaz-b854e6f9 puis
// velokaz-b85f9725) : tant qu'ils n'ont pas confirmé laquelle fait foi, envoyer les deux
// garantit que leur correctif prendra sans nouvelle intervention ici. À réduire à une seule
// clé dès leur réponse. Surchargeable en console via `greenleazeDepositKeys` (tableau).
const DEPOSIT_KEYS = ['additionnalInitialDeposit', 'additionalInitialDeposit'];

// Apport initial supplémentaire, variante par variante : { "<variant_id>": <montant TTC> }.
// Ne garde que les montants strictement positifs portant sur une variante RÉELLEMENT
// envoyée à Greenleaze : le panier transmis est souvent réduit (buildAcompteCart) et
// toujours purgé du marquage (stripMarquage), un id absent ferait porter l'apport sur un
// produit que l'API ne voit pas.
function sanitizeAdditionalDeposit(map, cart) {
  const out = {};
  if (!map || typeof map !== 'object') return out;
  const known = new Set(((cart && cart.items) || []).map((it) => String(it.variant_id)));
  Object.keys(map).forEach((key) => {
    const id = String(key);
    if (!known.has(id)) {
      // On dit AUSSI ce que contenait le panier transmis : sans ça, « variante absente » ne
      // permet pas de savoir si c'est la variante qui est fausse ou le panier qui a été réduit.
      console.warn(
        'Greenleaze: apport supplémentaire ignoré, variante absente du panier transmis:',
        id,
        '— variantes du panier transmis :',
        Array.from(known),
      );
      return;
    }
    const amount = Math.round((Number(map[key]) || 0) * 100) / 100;
    if (amount > 0) out[id] = amount;
  });
  return out;
}

async function sendCartAndRedirect(duration, variantId, pdistinctId, themeParams = null, options = {}) {
  // Only use semaphore if we're actually modifying the cart (adding a product)
  if (variantId && isProcessingCart) {
    if (window.greenleazeDebug) console.log('Cart operation already in progress, skipping...');
    return false;
  }

  // Set processing flag only if we're adding a product
  if (variantId) {
    isProcessingCart = true;
  }

  try {
    let cartContentsRes = await fetch(window.Shopify.routes.root + 'cart.js');
    let cartContents = await cartContentsRes.json();

    if (variantId) {
      const hasVariantId = cartContents.items.some((item) => item.variant_id == variantId);

      if (!hasVariantId) {
        // Add the bike first
        window.__mintAtcType = 'lld';
        await addTo(variantId, 1);
      } else if (typeof window.mintTrackAddToCart === 'function') {
        // Le velo est DEJA au panier : aucun /cart/add ne partira, donc l'intercepteur
        // de tracking-ecommerce.liquid n'a rien a voir. Sans cette branche, « Louer mon
        // velo » ne comptait que pour les clients dont le panier etait vide — un trou
        // invisible, puisque le parcours aboutissait normalement.
        // On normalise a quantity 1 : `existing.quantity` est la quantite TOTALE deja
        // au panier, la reporter telle quelle gonflerait l'ajout.
        const existing = cartContents.items.filter((item) => item.variant_id == variantId)[0];
        if (existing) {
          window.mintTrackAddToCart(
            [Object.assign({}, existing, { quantity: 1, final_line_price: existing.price })],
            'lld',
          );
        }
      }
    }

    if (window.theme && theme.cart && typeof theme.cart.syncMarquage === 'function') {
      await theme.cart.syncMarquage();
    }

    cartContentsRes = await fetch(window.Shopify.routes.root + 'cart.js');
    cartContents = await cartContentsRes.json();
    
    if (!trackingId) {
      try {
        const shopifyUser = typeof window.ShopifyAnalytics?.lib?.user === 'function'
          ? window.ShopifyAnalytics.lib.user()
          : null;
        trackingId = shopifyUser?.traits?.()?.uniqToken || crypto.randomUUID();
      } catch (e) {
        trackingId = crypto.randomUUID();
      }
    }
    
    // Mode acompte (réservation Greenleaze) : on n'envoie pas tout le panier, seulement le
    // produit réservé + son marquage. Nécessite un variantId (réservation depuis une FP).
    let payloadCart = cartContents;
    const useReservationFlow = !options?.forceRedirect && (options?.forceReservation || window.Greenleaze?.reservationModalEnabled);

    if (variantId && useReservationFlow) {
      payloadCart = buildAcompteCart(cartContents, variantId);
    }

    // Le marquage reste au panier Shopify (syncMarquage ci-dessus le maintient pour le
    // parcours achat) mais n'est jamais envoyé à Greenleaze : il ne fait pas partie du
    // contrat de location. Appliqué aux deux branches — panier complet comme panier réduit.
    payloadCart = stripMarquage(payloadCart);

    const payload = {
      cartContents: JSON.stringify(payloadCart),
      duration: duration,
      trackingId: trackingId,
      trackingData: null,
      postHogtrackingId: pdistinctId,
      themeParams: themeParams ? themeParams : null,
    };

    // Apport supplémentaire choisi par le client (curseur de la modale location).
    // Omis quand il n'y a rien à envoyer : l'apport par défaut du compte (10 %) s'applique
    // alors, comportement iso avec l'existant.
    const extraDeposit = sanitizeAdditionalDeposit(options?.additionnalInitialDeposit, payloadCart);
    if (Object.keys(extraDeposit).length) {
      // Clés : cf. DEPOSIT_KEYS. `window.greenleazeDepositKeys` les surcharge en console,
      // pour tester une orthographe (ou un tout autre champ, ex. `initialDeposit`) sans
      // redéployer — à combiner avec `greenleazeDepositAsTotal` côté modale si le champ
      // testé attend l'apport TOTAL et non le supplément.
      const keys = Array.isArray(window.greenleazeDepositKeys) ? window.greenleazeDepositKeys : DEPOSIT_KEYS;
      keys.forEach((k) => {
        payload[k] = extraDeposit;
      });
      if (window.greenleazeDebug) console.log('[greenleaze] send-card apport →', keys.join(' + '), extraDeposit);
    } else if (window.greenleazeDebug) {
      console.log('[greenleaze] send-card SANS apport (reçu :', options?.additionnalInitialDeposit, ')');
    }

    // Ce qui PART réellement, conservé pour inspection : le panier transmis est souvent
    // réduit (buildAcompteCart) et toujours purgé du marquage (stripMarquage), donc c'est ici,
    // pas dans la modale, qu'on voit si l'apport a survécu à sanitizeAdditionalDeposit.
    window.Greenleaze = window.Greenleaze || {};
    window.Greenleaze.lastSendCard = { url: '/apps/greenleaze-proxy/send-card', payload: payload, response: null };
    if (window.greenleazeDebug) console.log('[greenleaze] send-card ←', payload);

    let ack = await fetch('/apps/greenleaze-proxy/send-card', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
      body: JSON.stringify(payload),
    });

    if (ack.ok) {
      ack = await ack.json();
      window.Greenleaze.lastSendCard.response = ack;
      console.log('[greenleaze send-card response]', ack);
      if (ack?.message) {
        console.error(ack?.message);
      }

      // Mode réservation (acompte / LLD) : si la modale est activée (ou forcée), on ne
      // redirige JAMAIS en pleine page. On retourne l'ack pour que l'appelant charge l'URL
      // renvoyée (bookingUrl / reservationUrl, ou à défaut redirectUrl) dans l'iframe de la modale.
      // forceReservation force ce comportement même si le flag d'affichage global est off.
      // forceRedirect garde le parcours historique même si le flag global est on.
      // NB: le champ renvoyé par send-card est `bookingUrl` (alias historique: `reservationUrl`).
      if (useReservationFlow) {
        return ack;
      }

      if (ack?.redirectUrl) {
        window.location.href = ack?.redirectUrl + '&duration=' + duration;
      }
    } else {
      console.error("Une erreur s'est produite.");
      console.error('error during saved ', ack);
      return false;
    }

    return true;
  } catch (error) {
    console.error('Error in sendCartAndRedirect:', error);
    return false;
  } finally {
    // Only release the lock if we were actually processing cart modifications
    if (variantId) {
      isProcessingCart = false;
    }
  }
}

async function initGreenleaze() {
  if (init) return; // Évite double initialisation
  init = true; // Marque le début de l'initialisation
  if (window.greenleazeDebug) console.log('INITIALIAZING GREENLEAZE');
  try {
    await getAllPriceRules();
  } catch (error) {
    console.error('Erreur lors de l\'initialisation Greenleaze:', error);
    init = false; // Reset pour permettre une nouvelle tentative
    initPrice = false;
  }
}

if (!init) initGreenleaze();
